import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { Component } from "react";
import postService from "../../services/postService";
import CircularLoadingScreen from "../commons/CircularLoadingScreen";
import MiniPost from "./MiniPost";

class Trending extends Component {
  state = {
    loaded: false,
    posts: [],
    code: "week",
  };

  async componentDidMount() {
    setTimeout(async () => {
      await this.loadTrending();
    }, 500);
  }

  handleCodeChange = async () => {
    this.setState({
      loaded: false,
    });
    setTimeout(async () => {
      await this.loadTrending();
    }, 500);
  };

  loadTrending = async () => {
    const { category } = this.props;
    const { code } = this.state;
    const response = await postService.getTrending(code, category?.id);
    this.setState({
      loaded: true,
      posts: response.data.data,
    });
  };

  render() {
    const { category } = this.props;
    const { loaded, posts, code } = this.state;
    if (!loaded) {
      return (
        <div
          className="trending-box"
          style={{
            padding: "40px 0",
          }}
        >
          <CircularLoadingScreen
            thickness={5}
            containerStyles={{
              backgroundColor: "transparent",
            }}
          />
        </div>
      );
    }
    return (
      <div className="trending-box">
        <div
          style={{
            padding: "10px 15px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3
              style={{
                margin: 0,
              }}
            >
              Trending
            </h3>
            <FormControl variant="standard">
              <Select
                value={code}
                onChange={(e) => {
                  this.setState({
                    code: e.target.value,
                  });
                  this.handleCodeChange();
                }}
                disableUnderline
                style={{
                  fontFamily: 'inherit',
                  fontSize: 13
                }}
              >
                <MenuItem value={"day"}>Today</MenuItem>
                <MenuItem value={"week"}>This Week</MenuItem>
                <MenuItem value={"month"}>This Month</MenuItem>
                <MenuItem value={"all"}>All time</MenuItem>
              </Select>
            </FormControl>
          </div>
          {category && (
            <h5
              style={{
                margin: "5px 0",
                fontWeight: "normal",
              }}
            >
              in {category.name}
            </h5>
          )}
          <hr
            style={{
              marginBottom: 0,
              opacity: 0.5
            }}
          />
        </div>
        {posts.length > 0 ? (
          <>
            {posts.map((post) => (
              <MiniPost post={post} key={post.id} />
            ))}
          </>
        ) : (
          <div
            style={{
              width: '80%',
              margin: 'auto',
              textAlign: 'center',
              color: "grey",
              paddingTop: 10,
              paddingBottom: 10
            }}
          >
            No trending posts
            <br/>
            <span style={{
              fontSize: 14
            }}>Try changing the start date or category</span>
          </div>
        )}
      </div>
    );
  }
}

export default Trending;
